<ng-template #exportMsgTml let-msg="data">
  <div class="export-in-progress">
    <nz-spin nzSimple nzSize="small"></nz-spin>
    {{ msg }}
  </div>
</ng-template>
